import React from "react";
import PropTypes from "prop-types";

export default function ModalBody({
  CurrentScreenNumber,
  ModalChildren,
  goToPrevScreen,
  goToNextScreen,
  updatePropsOfAScreen,
}) {
  const renderComponentOfSelectedScreen = () => {
    const currentScreenComponent = ModalChildren.find(
      (eachItem) => eachItem.screenNumber === CurrentScreenNumber
    );

    if (currentScreenComponent) {
      const Component = currentScreenComponent.component;
      const ComponentProps = currentScreenComponent.props;
      return (
        <Component
          {...ComponentProps}
          goToNextScreen={goToNextScreen}
          goToPrevScreen={goToPrevScreen}
          updatePropsOfAScreen={updatePropsOfAScreen}
        />
      );
    }
    return <p className="text-center">Nothing to show</p>;
  };

  return (
    <div>{CurrentScreenNumber >= 0 && renderComponentOfSelectedScreen()}</div>
  );
}

ModalBody.propTypes = {
  CurrentScreenNumber: PropTypes.number,
  ModalChildren: PropTypes.array,
  goToPrevScreen: PropTypes.func,
  goToNextScreen: PropTypes.func,
  updatePropsOfAScreen: PropTypes.func,
};
